// extracted by mini-css-extract-plugin
module.exports = {"baseError":"BaseError_baseError_3a1cR"};